import { callEndpoint } from "../baseApi"

export const GetMobileAppDownloads = async (uuid, idToken) => {
  return await callEndpoint(`${process.env.REACT_APP_API}/apps/${uuid}/mobile_configs/downloads`, 'GET', idToken)
}

export const GetMobilePushSubscribers = async (uuid, idToken) => {
  return await callEndpoint(`${process.env.REACT_APP_API}/apps/${uuid}/mobile_configs/subscribers`, 'GET', idToken)
}